import React, { useMemo } from 'react';
import { shouldShowVocabularyQuizButton } from '../../utils/articleQuizUx';

export function ArticleVocabularyQuizButton({ article, label, disabled, onStart }) {
  if (!shouldShowVocabularyQuizButton(article)) return null;
  return (
    <div className="article-vocab-quiz-action">
      <button
        type="button"
        className="user-course-btn primary"
        data-article-quiz-start=""
        onClick={(event) => {
          event.stopPropagation();
          if (!disabled && onStart) onStart();
        }}
        disabled={disabled}
        aria-label={label}
      >
        <i className="material-icons" aria-hidden="true">quiz</i>
        {label}
      </button>
    </div>
  );
}

/** Article HTML, then the quiz button, inside the scrolling reader body. */
export function ArticleQuizReader({ article, html, quizLabel, quizDisabled, onStartQuiz }) {
  // React 19 rewrites innerHTML whenever this object changes, which would wipe the clickable words.
  const markup = useMemo(() => ({ __html: html || 'No content available' }), [html]);
  return (
    <>
      <div data-article-html="" dangerouslySetInnerHTML={markup} />
      <ArticleVocabularyQuizButton
        article={article}
        label={quizLabel}
        disabled={quizDisabled}
        onStart={onStartQuiz}
      />
    </>
  );
}
